import styled from 'styled-components/macro';
import { FlexCenterVertical } from 'styles/flexbox';
import { white } from 'variables/colors';
import { borderRadius, boxShadowHeavy } from 'variables/general';
import Button from '../Button';

export const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '2em',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

export const SubmitButton = styled(Button)`
  margin-left: auto;
`;

export const DeleteButton = styled.div`
  position: relative;
  white-space: nowrap;
`;

export const ConfirmDeleteContainer = styled.div`
  position: absolute;
  top: -10em;
  left: -1em;
  z-index: 100;
`;

export const ConfirmDelete = styled.div`
  padding: 1.5em;
  background-color: ${white};
  border-radius: ${borderRadius};
  box-shadow: ${boxShadowHeavy};
`;

export const DeleteText = styled.h4`
  margin-bottom: 1.5em;
`;

export const Buttons = styled(FlexCenterVertical)`
  gap: 0.5em;
`;
